import { clearAuthTokens, setAuthTokens } from "@/utils/auth";

import { publicClient } from "./client";

export async function login(username: string, password: string) {
  const { data } = await publicClient.POST("/api/token/", {
    body: { username, password },
  });
  setAuthTokens({ accessToken: data!.access, refreshToken: data!.refresh });
}

export async function logout() {
  clearAuthTokens();
}
